const CACHE = {};
const REGION = [
  null, '北海道', '青森県', '岩手県', '宮城県',
  '秋田県', '山形県', '福島県', '茨城県', '栃木県',
  '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
  '新潟県', '富山県', '石川県', '福井県', '山梨県',
  '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
  '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県',
  '和歌山県', '鳥取県', '島根県', '岡山県', '広島県',
  '山口県', '徳島県', '香川県', '愛媛県', '高知県',
  '福岡県', '佐賀県', '長崎県', '熊本県', '大分県',
  '宮崎県', '鹿児島県', '沖縄県'
];

export class Core {
  constructor(inputVal = '', callback) {
    this.URL = 'https://yubinbango.github.io/yubinbango-data/data';

    if (!inputVal) {
      return;
    }

    const normalized = inputVal.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248));
    const digits = (normalized.match(/\d/g) || []).join('');
    const postalCode = this.chk7(digits);

    if (postalCode) {
      this.getAddr(postalCode, callback);
      return;
    }

    callback(this.addrDic());
  }

  chk7(val) {
    if (val.length === 7) {
      return val;
    }

    return '';
  }

  addrDic(regionId = '', region = '', locality = '', street = '', extended = '') {
    return {
      region_id: regionId,
      region,
      locality,
      street,
      extended
    };
  }

  selectAddr(addr) {
    if (addr && addr[0] && addr[1]) {
      return this.addrDic(addr[0], REGION[addr[0]], addr[1], addr[2], addr[3]);
    }

    return this.addrDic();
  }

  jsonp(url, callback) {
    window.$yubin = (data) => callback(data);

    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.setAttribute('charset', 'UTF-8');
    scriptTag.setAttribute('src', url);
    document.head.appendChild(scriptTag);
  }

  getAddr(postalCode, callback) {
    const prefix = postalCode.substr(0, 3);

    if (CACHE[prefix] && CACHE[prefix][postalCode]) {
      callback(this.selectAddr(CACHE[prefix][postalCode]));
      return;
    }

    this.jsonp(`${this.URL}/${prefix}.js`, (data) => {
      CACHE[prefix] = data;
      callback(this.selectAddr(data[postalCode]));
    });
  }
}
